import {
  CheckCircleIcon,
  ExclamationIcon,
  XCircleIcon
} from "@heroicons/react/solid";

type AlertProps = {
  title: string;
  type: "success" | "error" | "warning";
  message?: string;
};

const renderAlert = ({ type, title, message }: AlertProps) => {
  switch (type) {
    case "success":
      return (
        <div className="rounded-md bg-green-100 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <CheckCircleIcon
                className="h-5 w-5 text-green-500"
                aria-hidden="true"
              />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800">{title}</h3>
              {message ? (
                <div className="mt-2 text-sm text-green-700">
                  <p>{message}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    case "error":
      return (
        <div className="rounded-md bg-red-100 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <XCircleIcon
                className="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">{title}</h3>
              {message ? (
                <div className="mt-2 text-sm text-red-700">
                  <p>{message}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    case "warning":
      return (
        <div className="bg-yellow-50 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <ExclamationIcon
                className="h-5 w-5 text-yellow-400"
                aria-hidden="true"
              />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-700">{title}</h3>
              {message ? (
                <div className="mt-2 text-sm text-yellow-700">
                  <p>{message}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
  }
};

export default function Alert(props: AlertProps): JSX.Element {
  return renderAlert(props);
}
